
import { supabase } from "@/integrations/supabase/client";
import { WidgetInfo } from './widget-types';

export const DASHBOARD_LAYOUT_KEY = "admin-dashboard-layout";

export const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

export interface WidgetSize {
  size: 'small' | 'medium' | 'large' | 'xlarge';
}

export interface LayoutItem extends WidgetSize {
  id: string;
}

export interface DashboardLayout {
  items: LayoutItem[];
}

// Map widget sizes to grid classes
export const sizeToGridClass = {
  'small': 'col-span-1',
  'medium': 'sm:col-span-2 col-span-1',
  'large': 'lg:col-span-3 sm:col-span-2 col-span-1',
  'xlarge': 'lg:col-span-4 sm:col-span-2 col-span-1'
};

// Default widget order with their sizes
export const DEFAULT_WIDGET_ORDER: LayoutItem[] = [
  { id: 'total-users', size: 'small' },
  { id: 'contracts', size: 'small' },
  { id: 'total-value', size: 'small' },
  { id: 'emails-sent', size: 'small' },
  { id: 'user-growth', size: 'medium' },
  { id: 'weekly-user-growth', size: 'medium' }, // Add the new widget
  { id: 'error-distribution', size: 'medium' },
  { id: 'bug-reports', size: 'medium' },
  { id: 'recent-errors', size: 'large' },
  { id: 'active-users', size: 'large' },
  { id: 'notable-users', size: 'medium' },
  { id: 'email-statistics', size: 'medium' },
  { id: 'invitations-stats', size: 'medium' }
];
